import localStorage from 'store';
import { v4 as uuid4 } from 'uuid';

import * as types from '../constants';

//User this for removing local storage after feature update
const CURRENT_VERSION = 0.002;
const CITY_UK = 'Київ';
const CITY_RU = 'Киев';
const CENTER_MARKER = {
  latitude: 50.4501,
  longitude: 30.5234,
};

let storeVersion = localStorage.get('version');

if (storeVersion !== CURRENT_VERSION) {
  localStorage.remove('user_location');
  localStorage.remove('location_confirmed');
  localStorage.remove('cart_items');
  localStorage.set('version', CURRENT_VERSION);
}

let userUuid = localStorage.get('uuid');

if (!userUuid) {
  userUuid = uuid4();
  localStorage.set('uuid', userUuid);
}

let lang = localStorage.get('lang');
let userLocation = localStorage.get('user_location');

let initialLocation = userLocation ?? CENTER_MARKER;

if (!initialLocation.name) {
  if (lang === 'uk' || !lang) {
    initialLocation.name = CITY_UK;
  } else if (lang === 'ru') {
    initialLocation.name = CITY_RU;
  }
}

let initialState = {
  uuid: userUuid, //client ident in future
  isLoading: false,
  error: null,
  location: initialLocation,
  locationConfirmed: localStorage.get('location_confirmed', false),
  favorites: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_GEOIP_BEGIN:
      return {
        ...state,
        location: null,
        error: null,
        isLoading: true,
      };
    case types.FETCH_GEOIP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        location: payload,
      };
    case types.FETCH_GEOIP_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case types.SET_LOCATION:
      return {
        ...state,
        location: payload,
        locationConfirmed: true,
      };
    case types.LOCATION_CONFIRM:
      return {
        ...state,
        locationConfirmed: payload,
      };
    case types.LOAD_FAVORITES:
      return {
        ...state,
        favorites: payload,
      };
    case types.ADD_TO_FAVORITES:
      return {
        ...state,
        favorites: payload,
      };
    default:
      return state;
  }
};
